const headerNavLinks = [
  { to: '/', title: 'Inicio', icon: 'home' },
  { to: '/cart', title: 'Carrinho', icon: 'shopping-cart' },
];

export default headerNavLinks;
